import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import get from 'lodash/get';
import Initializing from './Initializing';
import { logout } from '../utils/helpers/store';

class Loading extends Component {

  componentWillMount() {
    this.renderRedirect();
  }

  componentDidUpdate() {
    this.renderRedirect();
  }

  renderRedirect() {
    const { isAuthenticated, isLoggedIn, dispatch, redirectPath } = this.props;
    if (isLoggedIn && isAuthenticated) {
      if (redirectPath) {
        dispatch(push(redirectPath));
      } else {
        logout(dispatch);
      }
    } else if (!isAuthenticated) {
      dispatch(push('/login'));
    }
  }

  render() {
    return (
      <Initializing />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { user, auth } = state;
  const { location: { query: { redirect } } } = ownProps; 
  const isLoggedIn = get(user, 'data.uuid', 0) === get(auth, 'data.payload.sub', 1);
  const isAuthenticated = auth.data.isAuthenticated;
  const redirectPath = user.data.uuid ? getRedirectPath(redirect, user.data) : null;
  
  return { redirectPath, isLoggedIn, isAuthenticated };
};

const getRedirectPath = (redirect, user) => {
  let path;
  if (redirect) {
    path = redirect;
  } else if (user.isAdvertiser) {
    path = '/advertiser/home/accounts';
  } else if (user.isPublisher) {
    path = '/publisher/home/websites';
  } else if (user.isSsp) {
    path = '/ssp/websites';
  }
  return path;
};

export default connect(mapStateToProps)(Loading);
